module.exports = __webpack_public_path__ + "img/snails.5ab434fb.png";